import styled from 'styled-components'
import Switch from 'ui/components/forms/Switch'

export const StatusSwitch = styled(Switch)`
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;

  > span:last-child {
    margin-left: 0;
  }
`
